<template>
  <div>
    <header :class="customHeader" class="flex items-center cursor-pointer" @click="toggle">
        <div class="mr-2"
          >
            <base-button-icon 
              :class="{'rotate-180':active}" 
              class="transform transition-transform duration-150" 
              mode="primary-phantom" 
              name="chevrondown" 
              size="sm"
              :disabled="disabled"
              />
        </div>
        <slot name="headerRight"/>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-show="active" :class="overflowHidden ? 'overflow-hidden' : ''">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import BaseButtonIcon from './BaseButtonIcon.vue'
export default {
  components: { BaseButtonIcon },
  name: 'base-collapsible',
  props: {
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    overflowHidden: {
      type: Boolean,
      default: true,
    }
  },
  data: function () {
    return {
      active: false,
      disabled: false,
    }
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    },
    isActive () {
      return this.active
    }
  },
  methods: {
    toggle () {
      if (!this.disabled) this.active = !this.active
      this.$emit('toggle', this.active)
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
